// Session
export const SET_SESSION = 'SET_SESSION';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const SET_SHOW_VACCOUNT_MODAL = 'SET_SHOW_VACCOUNT_MODAL';
export const SET_VACCOUNT = 'SET_VACCOUNT';
export const SET_TAGNAME_ID = 'SET_TAGNAME_ID';
// Profile
export const SET_PROFILE = 'SET_PROFILE';
// Preferences
export const SET_APP_LANG = 'SET_APP_LANG';
